module.exports = __webpack_public_path__ + "static/media/elixatec.9fea3a3e.png";